import type React from 'react';

export interface NotificationCheckProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const NotificationCheck: React.FC<NotificationCheckProps> = ({
	width = 20,
	height = 22,
	color = 'currentColor',
	'aria-label': ariaLabel = 'Notifications Check Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 30 30"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
		style={{ color }}
	>
		<path
			d="M9.06641 15.4122L12.0884 18.4342L19.9456 10.577"
			stroke="currentColor"
			strokeLinecap="round"
		/>
		<path
			d="M14.5063 26.7901C11.7314 25.9658 9.4257 24.2845 7.58924 21.7462C5.75371 19.2071 4.83594 16.3469 4.83594 13.1658V5.69474L14.5063 2.08215L24.1768 5.69474V13.1658C24.1768 16.3469 23.259 19.2066 21.4235 21.7449C19.587 24.284 17.2813 25.9658 14.5063 26.7901ZM14.5063 25.3229C16.9009 24.5631 18.8811 23.0435 20.4467 20.764C22.0124 18.4846 22.7953 15.9518 22.7953 13.1658V6.6383L14.5063 3.55758L6.21742 6.6383V13.1658C6.21742 15.9518 7.00027 18.4846 8.56595 20.764C10.1316 23.0435 12.1118 24.5631 14.5063 25.3229Z"
			fill="currentColor"
		/>
	</svg>
);

export default NotificationCheck;

